<template>
    <ion-content class="light-light-background">
        <ion-grid class="mt-2">
            <add-product-interface
                :show-cart="userStore.permission[PERMISSION_KEY.CART_ADD]"
                :show-list="userStore.permission[PERMISSION_KEY.LIST_ITEM_CREATE]"
                :isMultiple="isMultiple"
                :isMax="isMax"
                v-model:amount="amount"
                :amountStep="product.amountStep"
                :amountMax="product.amountMax"
                :options="product.packaging"
                :name="product.name"
                @cart="checkOverrideCartProduct"
                @list="addList(product, amount, supplierId)"
            />
        </ion-grid>
    </ion-content>
</template>

<script setup lang="ts">
import { IonContent, IonGrid, modalController } from "@ionic/vue";
import { computed, ref } from "vue";
import { t } from "@/plugins/vue-i18n";

import { useListStore } from "@/stores/lists";
import { useUserStore } from "@/stores/user";

import { interactionFeedbackToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";

import { useProductModal } from "@/composables/viewFunctions/useProductModal";
import { useRouteParams } from "@/composables/useRouteParams";

import { PERMISSION_KEY } from "@/types/user";
import { AddProductModalPros } from "@/types/props";
import AddProductInterface from "@/components/modal/AddProductInterface.vue";

const props = defineProps<AddProductModalPros>()

const listStore = useListStore()
const userStore = useUserStore()
const { addList } = useProductModal(props.listId, { offset: props.offset })

const { locationId } = useRouteParams()

const amount = ref<number>(0)

const isMax = computed<boolean>(() => props.product.amountMax ? amount.value <= props.product.amountMax : true)
const isMultiple = computed<boolean>(() => (amount.value % (props.product.amountStep ?? 1)) === 0)

const addToCart = (): void => {
    modalController.dismiss()

    listStore.addItemToCart(locationId.value, props.product.id, amount.value, undefined, props.offset).then((response) => {
        if (response) {
            listStore.getShoppingCart(locationId.value)
            interactionFeedbackToast(
                response,
                {
                    type: 'addCart',
                    id: 'add-product-cart'
                },
                {
                    cssClass: `toast-offset-${props.offset ?? 50}`
                },
                true
            )
        }
    })
}

const checkOverrideCartProduct = async (): Promise<void> => {
    if (listStore.catalogItemInCart(props.product.id)) {
        popAlertConfirm({
            message: t('messages.list.overrideCartList'),
            cancelText: t('button.cancel'),
            handler: {
                ok: addToCart
            }
        })
        return
    }

    addToCart()
}
</script>
